var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { useUXPContext } from '@core/context/useUXPContext';
import { useLoadingFeedback } from '@widget/loaders';
import { logout } from './auth_services';
/**
 * @export
 * Returns a fucntion (logout) that will trigger the logout process
 */
export function useLogout() {
    const context = useUXPContext();
    const loading = useLoadingFeedback();
    return useCallback(() => __awaiter(this, void 0, void 0, function* () {
        loading.show({ message: context.$L('uxp-core.auth.logging-out') });
        yield logout();
    }), [context, loading]);
}
